import styled from 'styled-components';

export const GridsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const Grid = styled.div<{ width: string; height: string; extraStyles?: Record<string, string> }>`
	display: grid;
	gap: 12px;
	margin-right: 12px;
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	${({ extraStyles }) => extraStyles}
	&:last-of-type {
		margin-right: unset;
	}
`;

export const CardContainer = styled.div<{
	size: { width: string; height: string };
	position?: string | false;
}>`
	display: flex;
	justify-content: center;
	align-items: center;
	${({ size }) => size};
	${({ position }) => position};
`;
